// extracted by mini-css-extract-plugin
export default {"app":"routes_app__LWaRx","hidden":"routes_hidden__gS-YP"};